import { useState } from 'react';
import { useLocation } from 'react-router-dom';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const isActive = (path: string) => location.pathname === path;

  return (
    <header className="w-full bg-white/95 backdrop-blur-sm shadow-sm sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <div 
            className="flex items-center cursor-pointer group"
            onClick={() => window.REACT_APP_NAVIGATE('/')}
          >
            <div className="w-10 h-10 bg-gradient-to-br from-slate-800 to-slate-600 rounded-lg flex items-center justify-center mr-3 shadow-lg group-hover:shadow-xl transition-all duration-300 transform group-hover:scale-105">
              <div className="relative">
                <div className="w-6 h-6 border-2 border-yellow-400 rounded-sm transform rotate-45"></div>
                <div className="absolute top-1 left-1 w-4 h-4 bg-yellow-400 rounded-sm"></div>
              </div>
            </div>
            <span className="text-2xl font-bold bg-gradient-to-r from-slate-800 to-slate-600 bg-clip-text text-transparent">
              Goodwin Developments
            </span>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-1">
            <button
              onClick={() => window.REACT_APP_NAVIGATE('/')}
              className={`px-4 py-2 rounded-lg font-medium transition-all duration-300 whitespace-nowrap cursor-pointer ${
                isActive('/') 
                  ? 'bg-slate-900 text-white shadow-lg' 
                  : 'text-slate-700 hover:bg-slate-100'
              }`}
            >
              Home
            </button>
            <button
              onClick={() => window.REACT_APP_NAVIGATE('/rentals')}
              className={`px-4 py-2 rounded-lg font-medium transition-all duration-300 whitespace-nowrap cursor-pointer ${
                isActive('/rentals') 
                  ? 'bg-slate-900 text-white shadow-lg' 
                  : 'text-slate-700 hover:bg-slate-100'
              }`}
            >
              Rentals
            </button>
            <button
              onClick={() => window.REACT_APP_NAVIGATE('/dscr')}
              className={`px-4 py-2 rounded-lg font-medium transition-all duration-300 whitespace-nowrap cursor-pointer ${
                isActive('/dscr') 
                  ? 'bg-slate-900 text-white shadow-lg' 
                  : 'text-slate-700 hover:bg-slate-100'
              }`}
            >
              DSCR
            </button>
            <button
              onClick={() => window.REACT_APP_NAVIGATE('/hosting')}
              className={`px-4 py-2 rounded-lg font-medium transition-all duration-300 whitespace-nowrap cursor-pointer ${
                isActive('/hosting') 
                  ? 'bg-slate-900 text-white shadow-lg' 
                  : 'text-slate-700 hover:bg-slate-100'
              }`}
            >
              Hosting
            </button>
            <button
              onClick={() => window.REACT_APP_NAVIGATE('/#contact')}
              className="ml-4 px-6 py-2 bg-gradient-to-r from-emerald-600 to-blue-600 text-white rounded-lg font-semibold hover:from-emerald-700 hover:to-blue-700 transition-all duration-300 shadow-lg hover:shadow-xl transform hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              Contact Us
            </button>
          </nav>

          {/* Mobile menu button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden p-2 rounded-lg text-slate-700 hover:bg-slate-100 transition-colors duration-300 cursor-pointer"
          >
            <i className={`${isMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <nav className="md:hidden py-4 border-t border-slate-200">
            <div className="flex flex-col space-y-2">
              <button
                onClick={() => {
                  window.REACT_APP_NAVIGATE('/');
                  setIsMenuOpen(false);
                }}
                className={`px-4 py-3 rounded-lg font-medium transition-all duration-300 text-left whitespace-nowrap cursor-pointer ${
                  isActive('/') 
                    ? 'bg-slate-900 text-white shadow-lg' 
                    : 'text-slate-700 hover:bg-slate-100'
                }`}
              >
                Home
              </button>
              <button
                onClick={() => {
                  window.REACT_APP_NAVIGATE('/rentals');
                  setIsMenuOpen(false);
                }}
                className={`px-4 py-3 rounded-lg font-medium transition-all duration-300 text-left whitespace-nowrap cursor-pointer ${
                  isActive('/rentals') 
                    ? 'bg-slate-900 text-white shadow-lg' 
                    : 'text-slate-700 hover:bg-slate-100'
                }`}
              >
                Rentals
              </button>
              <button
                onClick={() => {
                  window.REACT_APP_NAVIGATE('/dscr');
                  setIsMenuOpen(false);
                }}
                className={`px-4 py-3 rounded-lg font-medium transition-all duration-300 text-left whitespace-nowrap cursor-pointer ${
                  isActive('/dscr') 
                    ? 'bg-slate-900 text-white shadow-lg' 
                    : 'text-slate-700 hover:bg-slate-100'
                }`}
              >
                DSCR
              </button>
              <button
                onClick={() => {
                  window.REACT_APP_NAVIGATE('/hosting');
                  setIsMenuOpen(false);
                }}
                className={`px-4 py-3 rounded-lg font-medium transition-all duration-300 text-left whitespace-nowrap cursor-pointer ${
                  isActive('/hosting') 
                    ? 'bg-slate-900 text-white shadow-lg' 
                    : 'text-slate-700 hover:bg-slate-100'
                }`}
              >
                Hosting
              </button>
              <button
                onClick={() => {
                  window.REACT_APP_NAVIGATE('/#contact');
                  setIsMenuOpen(false);
                }}
                className="px-4 py-3 bg-gradient-to-r from-emerald-600 to-blue-600 text-white rounded-lg font-semibold hover:from-emerald-700 hover:to-blue-700 transition-all duration-300 shadow-lg text-left whitespace-nowrap cursor-pointer"
              >
                Contact Us
              </button>
            </div>
          </nav>
        )}
      </div>
    </header>
  );
}
